<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>

    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px" toggleable="lg" type="dark"
          variant="primary">
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Freight Invoice For Billing - Sea Import</b-navbar-brand>
          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button style="font-size: 0.675rem; margin-left: 5px" @click="
                proceedAssignmentProforma(
                  ffInvoiceModal.allModuleId,
                  0,
                  ffInvoiceModal.jobNo
                )
                " size="sm" class="ml-1" variant="outline-info">Proceed To Proforma</b-button>

              <!-- :disabled="$sessionsStorage.get('nameUser') != 'Bhavneesh'?true:false" -->
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <div>
              <div class="box" v-if="PreviousPerformaList.length > 0">
                <div class="box-body row">
                  <div class="col-md-2" v-for="(pre_item, pre_index) in PreviousPerformaList" :key="pre_index">
                    <b-button style="font-size: 0.675rem" class="mt-2" v-if="pre_item.profarmaSeries" size="sm"
                      @click="getPreviousTallyData(pre_item)" variant="info">
                      <b>{{ pre_item.profarmaSeries }}</b>
                    </b-button>
                  </div>
                </div>
              </div>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="45">
                  <md-layout md-flex="100">
                    <label>Job No.</label>
                    <b-form-input :formatter="capitalizeAll" disabled id="clientName" name="clientName"
                      v-model="ffInvoiceModal.jobNo"></b-form-input>
                  </md-layout>
                </md-layout>
                <!-- <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="45">
              <md-layout md-flex="100">
                <label>Date</label>
                <b-form-input :formatter="capitalizeAll"
                  id="clientName"
                  disabled
                  name="clientName"
                  v-model="ffInvoiceModal.invDate"
                ></b-form-input>
              </md-layout>
            </md-layout>-->
                <md-layout md-flex="20"></md-layout>
                <md-layout md-flex="35">
                  <label for="containerTypeId">Invoice Status</label>
                  <model-list-select :list="invoiceStatusList" v-model="ffInvoiceModal.invoiceStatus" option-value="inv"
                    option-text="int" placeholder="Select Status"></model-list-select>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="45">
                  <md-layout md-flex="100">
                    <label>Client Name</label>
                    <b-form-input :formatter="capitalizeAll" id="clientName" disabled name="clientName"
                      v-model="ffInvoiceModal.clientName"></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <!-- <md-layout md-flex="50">
              <md-layout md-flex="100">
                <label>Client Contact</label>
                <b-form-input :formatter="capitalizeAll" id="clientName" name="clientName" v-model="ffInvoiceModal.contact"></b-form-input>
              </md-layout>
            </md-layout> -->
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="100">
                  <md-layout md-flex="100">
                    <label>Client Address</label>
                    <b-form-textarea :formatter="capitalizeAll" id="clientRegistrationNo" name="clientRegistrationNo"
                      v-model="ffInvoiceModal.adress"></b-form-textarea>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="45">
                  <md-layout md-flex="100">
                    <label>Place Of Receipt*</label>
                    <b-form-input :formatter="capitalizeAll" id="clientName" name="clientName"
                      v-model="ffInvoiceModal.POR"></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="50">
                  <md-layout md-flex="100">
                    <label>Load Port*</label>
                    <b-form-input :formatter="capitalizeAll" id="clientName" name="clientName"
                      v-model="ffInvoiceModal.LP"></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="45">
                  <md-layout md-flex="100">
                    <label>Port Of Discharge*</label>
                    <b-form-input :formatter="capitalizeAll" id="clientName" name="clientName"
                      v-model="ffInvoiceModal.POD"></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="50">
                  <md-layout md-flex="100">
                    <label>Final Place of Delivery*</label>
                    <b-form-input :formatter="capitalizeAll" id="clientName" name="clientName"
                      v-model="ffInvoiceModal.FPOD"></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="45">
                  <md-layout md-flex="100">
                    <label>Shipping Bill No/ BOE*</label>
                    <b-form-textarea :formatter="capitalizeAll" id="clientName" name="clientName"
                      v-model="ffInvoiceModal.BOE"></b-form-textarea>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="50">
                  <md-layout md-flex="100">
                    <label>BL No*</label>
                    <b-form-textarea :formatter="capitalizeAll" id="clientName" name="clientName"
                      v-model="ffInvoiceModal.blNo"></b-form-textarea>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="45">
                  <md-layout md-flex="100">
                    <label>Shipper Invoice No.*</label>
                    <b-form-textarea :formatter="capitalizeAll" id="clientRegistrationNo" name="clientRegistrationNo"
                      v-model="ffInvoiceModal.shipperInvNo"></b-form-textarea>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="50">
                  <md-layout md-flex="100">
                    <label>Shipper Invoice Date*</label>
                    <b-form-textarea :formatter="capitalizeAll" id="clientRegistrationNo" name="clientRegistrationNo"
                      v-model="ffInvoiceModal.shipperInvDate"></b-form-textarea>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="45">
                  <md-layout md-flex="100">
                    <label>Vessel/Voy*</label>
                    <b-form-textarea :formatter="capitalizeAll" id="clientName" name="clientName"
                      v-model="ffInvoiceModal.vessel"></b-form-textarea>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="50">
                  <md-layout md-flex="100">
                    <label>Weight (KGS)*</label>
                    <b-form-textarea :formatter="capitalizeAll" id="clientName" name="clientName"
                      v-model="ffInvoiceModal.weight"></b-form-textarea>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="45">
                  <md-layout md-flex="100">
                    <label>Shipping Line Name*</label>
                    <b-form-textarea :formatter="capitalizeAll" id="clientName" name="clientName"
                      v-model="ffInvoiceModal.shippingLine"></b-form-textarea>
                  </md-layout>
                </md-layout>
                <!-- <md-layout md-flex="5"></md-layout>
  <md-layout md-flex="50">
              <md-layout md-flex="100">
                <label>Port Charges Details*</label>
                <b-form-textarea :formatter="capitalizeAll"
                  id="PortAdditionalCharges"
                  name="PortAdditionalCharges"
                  v-model="ffInvoiceModal.PortAdditionalCharges"
                ></b-form-textarea>
              </md-layout>
            </md-layout> -->
              </md-layout>

              <md-layout md-gutter class="gutr mt-3">
                <md-layout md-flex="30">
                  <h5><b-badge>Container Details</b-badge></h5>
                </md-layout>
              </md-layout>
              <div class="gutr mt-2">
                <md-layout md-gutter class="mt-2">
                  <md-layout md-flex="45">
                    <md-layout md-flex="100">
                      <b-form-input :formatter="capitalizeAll" disabled class="gutr"
                        v-for="(item, index) in ffInvoiceModal.containerDetails" :key="index" id="clientRegistrationNo"
                        name="clientRegistrationNo" :value="item"></b-form-input>
                    </md-layout>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="50">
                    <md-layout md-flex="100">
                      <b-form-input :formatter="capitalizeAll" disabled class="gutr"
                        v-for="(item1, index) in ffInvoiceModal.multipleContainerType" :key="index"
                        id="clientRegistrationNo" name="clientRegistrationNo" :value="item1"></b-form-input>
                    </md-layout>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <!-- <md-layout md-flex="10">
                <md-layout md-flex="100">
                  <b-form-input :formatter="capitalizeAll"
                    class="gutr"
                    v-for="(item3, index) in ffInvoiceModal.multiConNo"
                    :key="index"
                    id="clientRegistrationNo"
                    name="clientRegistrationNo"
                    :value="item3"
                  ></b-form-input>
                </md-layout>
              </md-layout>-->
                </md-layout>
              </div>
              <Profit-Loss v-if="ffInvoiceModal.allModuleId" :PMS_fk_all_module_id="ffInvoiceModal.allModuleId"
                :PMS_jb_series="ffInvoiceModal.jobNo" :PMS_fk_client_id="ffInvoiceModal.clientName"
                :PLAccordianStatus="false" :PLAccordianButton="true" />
              <Assignment-Timeline :TMAccordianStatus="false" :TMAccordianButton="true"
                :allModuleId="Number(ffInvoiceModal.allModuleId)" />
              <Payment-Summary v-if="ffInvoiceModal.allModuleId" :PMS_fk_all_module_id="ffInvoiceModal.allModuleId"
                :PMS_jb_series="ffInvoiceModal.jobNo" :PMS_fk_client_id="ffInvoiceModal.clientName" />
              <md-layout md-gutter class="gutr mt-3">
                <md-layout md-flex="30">
                  <h5><b-badge>Charges</b-badge></h5>
                </md-layout>
              </md-layout>
              <div class="box">
                <div class="box-body">
                  <table id="quotationDetail" class="table table-light table-bordered">
                    <thead>
                      <tr>
                        <th>
                          <b-button variant="success" size="sm" @click="addQuotationFields">
                            <!-- @click="addQuotationFields" -->
                            <md-icon>add</md-icon>
                          </b-button>
                        </th>

                        <th>Particulars</th>
                        <th>Container Type</th>
                        <th>Quantity</th>
                        <th>Currency</th>
                        <th>Quotation Rate</th>
                        <th>Selling Rate</th>
                        <th>Exch Rate</th>
                        <th>Invoice Amount(Without Taxes)</th>
                        <th>Unit</th>
                        <th>Remarks</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in ffTallyInvoiceData" :key="index">
                        <td>
                          <b-button variant="danger" size="sm" @click="removeCol(index)">
                            <md-icon>remove</md-icon>
                          </b-button>
                        </td>
                        <!-- <td>{{index+1}}</td> -->
                        <td>
                          <model-list-select :list="$store.getters['common/getAllLedgerList']" v-model="item.ffType"
                            option-value="ledger" option-text="ledger" placeholder="Select Particular">
                          </model-list-select>
                          <!-- <model-list-select
                            :list="ledgerData"
                            v-model="item.ffType"
                            option-value="ledger"
                            option-text="ledger"
                            placeholder="Select Type"
                          ></model-list-select> -->
                          <!-- <b-form-input :formatter="capitalizeAll" :disabled="item.mainffId!=''?true:false" v-model="item.ffType"></b-form-input> -->
                        </td>
                        <td>
                          <model-list-select :list="containerMasterData" v-model="item.containerType"
                            option-value="containerType" option-text="containerType"
                            placeholder="Select Type"></model-list-select>
                        </td>

                        <td>
                          <b-form-input :formatter="capitalizeAll" @input="getFinalAmount(index)" type="number"
                            v-model="item.quantity"></b-form-input>
                        </td>
                        <td>
                          <model-list-select :list="currencyList" v-model="item.currency" option-value="currencyV"
                            option-text="currencyT" placeholder="Select"></model-list-select>
                        </td>
                        <td>
                          <b-form-input :formatter="capitalizeAll" @input="getFinalAmount(index)" type="number"
                            :disabled="item.ffSellingRate ? true : false" v-model="item.ffSellingRate"></b-form-input>
                        </td>
                        <td>
                          <b-form-input :formatter="capitalizeAll" @input="getFinalAmount(index)" type="number"
                            v-model="item.sellingRateFinal"></b-form-input>
                        </td>

                        <td>
                          <!-- :disabled="item.ffSellingRate==''?true:false" -->
                          <b-form-input :formatter="capitalizeAll" @input="getFinalAmount(index)" type="number"
                            v-model="item.exchRate"></b-form-input>
                        </td>
                        <td>
                          <b-form-input :formatter="capitalizeAll" v-model="item.invAmount"></b-form-input>
                        </td>
                        <td>
                          <model-list-select :list="unitList" v-model="item.unit" option-value="unitId"
                            option-text="unitName" placeholder="Select"></model-list-select>
                        </td>
                        <td>
                          <b-form-input :formatter="capitalizeAll" v-model="item.remark"></b-form-input>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <!-- <md-layout md-gutter class="gutr">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="40">
              <md-layout md-flex="100">
                <label>Job No.</label>
                <b-form-input :formatter="capitalizeAll"
                  disabled
                  id="clientName"
                  name="clientName"
                  v-model="ffInvoiceModal.chnageApprovalStatus"
                ></b-form-input>
              </md-layout>
            </md-layout>
          </md-layout>-->
              <ExpenseTableComponent
                v-if="ffInvoiceModal.allModuleId && is_noe_validation"
                :show-debug="false"
                :initial-expenses="initialExpenses"
                :enable-validation="true"
                ref="expenseTableComponent"
                @expenses-saved="handleExpensesSaved"
                @expense-validation="handleExpenseValidation"
                :allModuleId="ffInvoiceModal.allModuleId"
                :jobNo="ffInvoiceModal.jobNo"
                :moduleType="'FF'"
                :transportType="'Import'"
                :branchId="$sessionsStorage.get('branch_baseLocation')"
                :invoiceStatus="ffInvoiceModal.invoiceStatus"
              />
              <OldExpenseAdditionalTask
                v-if="ffInvoiceModal.allModuleId"
                :allModuleId="ffInvoiceModal.allModuleId"
                :type="'additional-task'"
              />
              <!-- /.box-body -->
              <md-layout md-gutter class="mrgtop-2per">
                <!-- v-if="validateTally==false" -->
                <md-layout md-flex="50">
                  <b-button class="mt-3" :disabled="(DisableSubmit == '0' || validSubmit == false) &&
                    $store.getters['common/getAllSuccessInvoiceTB']
                      .InvoiceTypeKeyFlag == true
                    ? true
                    : false
                    " variant="primary" @click="submitInvoice('1')" id="addButtonLoader">{{
                      ffInvoiceModal.invoiceStatus == "0"
                        ? "Save & Send To Billing"
                        : "Save & Submit"
                    }}</b-button>
                  <span v-if="updateTime != 'null' && editUserName != 'null'" style="
                      mmargin-top: auto;
                      margin-bottom: auto;
                      padding-top: 20px;
                      margin-left: 20px;
                    ">Last Updated At : <span style="color: red">{{ updateTime }}</span> ,
                    By : <span style="color: red">{{ editUserName }}</span></span><br />
                  <div v-if="
                    $store.getters['common/getAllSuccessInvoiceTB']
                      .BillingSeriesDataString
                  ">
                    Invoice No.
                    <span style="color: red">{{
                      $store.getters["common/getAllSuccessInvoiceTB"]
                        .BillingSeriesDataString
                    }}</span>
                    genrated.
                    <span v-if="
                      $store.getters['common/getAllSuccessInvoiceTB']
                        .InvoiceTypeKeyFlag == true
                    ">Cannot be re-submitted</span>
                  </div>
                  <md-spinner md-indeterminate id="loader" style="display: none"></md-spinner>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="mrgtop-2per">
                <md-layout md-flex="20">
                  <!-- <b-button
                 :disabled="DisableSubmit=='0'?true:false"
                variant="primary"
                v-if="validateTally==true"
               class="mt-3"
                @click="submitInvoice('2')"
              >Send For Approval</b-button> -->
                </md-layout>
              </md-layout>
              <!-- <md-layout md-gutter class="mrgtop-2per">
            <md-layout md-flex="80"></md-layout>
            <md-layout md-flex="20">
            
              <md-button
                class="md-raised md-primary md-button-color"
                @click="ProceedBilling"
              >Proceed To Billing</md-button>
            </md-layout>
          </md-layout>-->
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPopMaxPer"></md-dialog-alert>

    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop6"></md-dialog-confirm>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { getJobNatureOfExpenseList, globalPermissionStatus } from "../../helper/collection";
import PaymentSummary from "../common/paymentSummary.vue";
import ProfitLoss from "../common/profitLoss.vue";
import AssignmentTimeline from "../common/assignmentTimeline.vue";
import ExpenseTableComponent from "../common/expenseTableComponent.vue";
import OldExpenseAdditionalTask from "../allModuleForm/components/OldExpenseAdditionalTask.vue";
export default {
  beforeMount() {
    this.$store.dispatch(
      "common/setAllLedgerList",
      JSON.stringify({
        itemCode: "LedgerList",
        JobType: this.$route.query.JobType,
        ShipmentType: this.$route.query.ShipmentType,
        ModuleType: this.$route.query.ModuleType,
        isLedgerActive: '1',
      })
    );
    if (globalPermissionStatus("Sea Freight")) {
      this.$store.dispatch("setCurrentRoute", "/freightForward/freightInvoiceForTally");
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  data() {
    return {
      PreviousPerformaList: [],
      updateTime: "null",
      editUserName: "null",
      unitList: [],
      invoiceStatusList: [
        {
          inv: "1",
          int: "In-Progress",
        },
        {
          inv: "0",
          int: "Closed",
        },
      ],
      validateTally: false,
      currencyList: [
        {
          currencyV: "INR",
          currencyT: "INR",
        },
        {
          currencyV: "USD",
          currencyT: "USD",
        },
        {
          currencyV: "EURO",
          currencyT: "EURO",
        },
        {
          currencyV: "GBP",
          currencyT: "GBP",
        },
        {
          currencyV: "ZAR",
          currencyT: "ZAR",
        },
        {
          currencyV: "CAD",
          currencyT: "CAD",
        },
        {
          currencyV: "JOD",
          currencyT: "JOD",
        },
        {
          currencyV: "AED",
          currencyT: "AED",
        },
      ],
      isLoading: false,
      containerNoName: [],
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      ledgerData: [],
      containerMasterData: [],
      ffInvoiceModal: {
        invoiceStatus: "1",
        chnageApprovalStatus: "",
        InvTallyId: "",
        invDate: "",
        jobNo: "",
        ffImportId: this.$sessionsStorage.get("editffSeaImportId"),
        allModuleId: "",
        ccTypeExImp: "",
        PortAdditionalCharges: "",
        totalAmount: "",
        weight: "",
        vessel: "",
        blNo: "",
        shipperInvNo: "",
        shipperInvDate: "",
        BOE: "",

        clientName: "",
        contact: "",
        adress: "",
        POR: "",
        LP: "",
        POD: "",
        FPOD: "",
        containerDetails: [],
        multipleContainerType: [],
        multiConNo: [],
        shippingLine: "",
      },
      DisableSubmit: "",
      validSubmit: "",
      validateInvoice: true,
      ffTallyInvoiceData: [],
      ffInvSummaryData: [],
      expenseValidation: {
        isValid: true,
        messages: [],
        fieldErrors: {}
      },
      initialExpenses: [],
      is_noe_validation: false,
    };
  },

  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  mounted() { },

  beforeDestroy() { },

  destroyed() { },

  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    PaymentSummary,
    ProfitLoss,
    AssignmentTimeline,
    ExpenseTableComponent,
    OldExpenseAdditionalTask,
  },
  watch: {
    ffInvoiceModal: {
      handler: function (newVal, oldVal) {
        if (
          this.ffInvoiceModal.POR == "" ||
          this.ffInvoiceModal.POD == "" ||
          this.ffInvoiceModal.LP == "" ||
          this.ffInvoiceModal.FPOD == "" ||
          this.ffInvoiceModal.ccSbNo == "" ||
          this.ffInvoiceModal.ccSbNoDate == "" ||
          this.ffInvoiceModal.ccshipInvDate == "" ||
          this.ffInvoiceModal.ccShipInvNo == "" ||
          this.ffInvoiceModal.vessel == "" ||
          this.ffInvoiceModal.blNo == "" ||
          this.ffInvoiceModal.weight == "" ||
          this.ffInvoiceModal.shippingLine == ""
        ) {
          this.validSubmit = false;
        } else {
          this.validSubmit = true;
        }
      },

      deep: true,
    },
  },
  computed: {},
  methods: {
    getJobNatureOfExpenseList() {
      this.is_noe_validation = false; // Reset to false initially
      console.log("allModuleId", this.allModuleId)
      let payload = { module_id: this.ffInvoiceModal.allModuleId, jobNo: this.ffInvoiceModal.mainSalesSeries, moduleType: this.$route.query.ModuleType, };
      getJobNatureOfExpenseList(payload, (error, result) => {
        if (error) {
          console.log("Catch on getNatureOfExpense Error: ", error);
          this.isSubmited = false;
        } else {
          console.log("NatureOfExpense result:", result);
          if (result && result.natureOfExpense) {
            this.natureOfExpense = result.natureOfExpense;
            this.is_noe_validation = result.is_noe_validation;
            // Also populate natureOfExpenseOptions for the dropdown
            // this.natureOfExpenseOptions = [...this.natureOfExpense];
          }
        }
        this.isLoading = false;
      });
    },
    ProceedBilling() {
      this.$router.push({
        path: "/allModuleForm/billing",
      });
    },
    getQuotRate() {
      let count1 = 0;
      this.ffTallyInvoiceData.map((x, index) => {
        if (x.quantity != "") {
          let finalAmt = parseInt(x.quantity) * parseInt(x.sellingRateFinal);
          x.invAmount = finalAmt;
        }
      });
      let count = 0;
      this.ffTallyInvoiceData.map((x, index) => {
        if (x.sellingRateFinal != "") {
          if (parseInt(x.sellingRateFinal) >= parseInt(x.ffSellingRate)) {
            count++;
          }
        }
      });
      if (count < this.ffTallyInvoiceData.length) {
        this.validateTally = true;
      } else {
        this.validateTally = false;
      }
      // console.log(
      //   parseInt(item.sellingRateFinal) < parseInt(item.ffSellingRate)
      // );
      // if (item.sellingRateFinal < item.ffSellingRate) {
      //   this.validateTally = true;
      // } else {
      //   this.validateTally = false;
      // }
    },
    proceedAssignmentProforma(all_module_id, isConsolidation, mainSalesSeries) {
      // newContainerFlow,
      this.$sessionsStorage.set("editSalesExId", all_module_id);
      if (isConsolidation == "1") {
        console.log("Consolidation");
        this.$router.push({
          path: "/consolidation/viewBillingDetails/" + all_module_id,
          query: { mainSalesSeries: mainSalesSeries },
        });
      } else {
        this.$router.push({
          path: "/common/assignmentPerforma/" + all_module_id,
        });
      }
    },
    getFinalAmount(ind) {
      let count = 0;
      this.ffTallyInvoiceData[ind].invAmount =
        parseFloat(this.ffTallyInvoiceData[ind].quantity) *
        parseFloat(this.ffTallyInvoiceData[ind].sellingRateFinal) *
        parseFloat(this.ffTallyInvoiceData[ind].exchRate);
      if (
        parseInt(this.ffTallyInvoiceData[ind].sellingRateFinal) <
        parseInt(this.ffTallyInvoiceData[ind].ffSellingRate)
      ) {
        this.validateTally = true;
      } else {
        this.validateTally = false;
      }
      // let count = 0;
      // this.ffTallyInvoiceData.map((x, index) => {
      //   if (x.quantity != "") {
      //     let finalAmt = parseInt(x.quantity) * parseInt(x.sellingRateFinal);
      //     x.invAmount = finalAmt;
      //   }
      // });
    },
    submitInvoice(id) {
      this.ffInvoiceModal.expenseData = [];
      this.ffInvoiceModal.totalExpenseAmount = 0;
      // Get all expense data from child component
      let allExpenseData = [];
      if (this.$refs.expenseTableComponent && this.is_noe_validation) {
        // First validate expenses
        const expenseValidationResult = this.$refs.expenseTableComponent.validateExpensesForParent();
        if (!expenseValidationResult) {
          this.alert.content = "Please fix expense validation errors before submitting.";
          this.$refs["addPop"].open();
          return false;
        }

        // Get all expense data using simple common function
        const expenseData = this.getExpenseDataSimple();
        const expenseDataAll = this.getExpenseData();
        console.log("All Expense Data:", expenseData);
        console.log("All Expense Data All:", expenseDataAll);

        // Add to ffInvoiceModal
        this.ffInvoiceModal.expenseData = expenseData.all;
        this.ffInvoiceModal.totalExpenseAmount = expenseData.total;
      }
      this.ffInvoiceModal["ffTallyInvoiceData"] = this.ffTallyInvoiceData;
      this.ffInvoiceModal["buttonId"] = id;
      let total = 0;

      this.ffTallyInvoiceData.map((x) => {
        let dummy = parseInt(x.invAmount) + total;
        total = dummy;
      });

      this.ffInvoiceModal.totalAmount = total;
      console.log(this.ffInvoiceModal);
      if (this.validateInvoice != false) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addInvoiceTallyFF.php`,
          data: JSON.stringify(this.ffInvoiceModal),

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.msg == "Inserted Successfully") {
                this.alert.content = "Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
              }
              $("#addButtonLoader").css("display", "block");
              $("#loader").css("display", "none");
              this.$refs["addPop"].open();
              this.getData();
            }
          })
          .catch((err) => {
            throw err;
          });
      }
    },
    removeCol(index) {
      this.ffTallyInvoiceData.splice(index, 1);
    },
    addQuotationFields() {
      let tableFields = {
        ffType: "",
        containerType: "",
        quantity: "",
        ffSellingRate: "",
        sellingRateFinal: "",
        exchRate: "1",
        invAmount: "",
        currency: "",
        remark: "",
        mainffId: "",
      };

      this.ffTallyInvoiceData.push(tableFields);
    },
    getData() {
      this.isLoading = true;
      this.ffTallyInvoiceData = [];
      let type_Size = {
        itemCode: "itemCode",
        ffImportId: this.$sessionsStorage.get("editffSeaImportId"),
        // ffExecutionId: this.$sessionsStorage.get("editFFExecutionId"),
        // ffBookingId: this.$sessionsStorage.get("editFFBookingId")
      };
      console.log(type_Size);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaImport/fetchToFFInvoiceTallImport.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data);

            let TParti = [];
            let TCon = [];
            let TSelO = [];
            let TSF = [];
            let TINV = [];
            let TCUR = [];
            let TRE = [];

            let EXRT = [];
            let QUN = [];
            let UN = [];
            let CON_NO = [];
            let CONTYPE = [];
            if (data.PreviousPerformaList.length > 0) {
              this.PreviousPerformaList = data.PreviousPerformaList;
            }
            if (data.tallyTableData.length > 0) {
              console.log(data);
              this.DisableSubmit = data.tallyTableData[0].invoiceStatus;
              Object.keys(data.tallyTableData[0]).map((x) => {
                if (x == "particulars") {
                  if (data.tallyTableData[0][x] != null) {
                    TParti = data.tallyTableData[0][x].split(",");
                  } else {
                    TParti = [];
                  }
                } else if (x == "containerType") {
                  if (data.tallyTableData[0][x] != null) {
                    TCon = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    TCon = [];
                  }
                } else if (x == "quotationRate") {
                  if (data.tallyTableData[0][x] != null) {
                    TSelO = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    TSelO = [];
                  }
                } else if (x == "sellingRateFinal") {
                  if (data.tallyTableData[0][x] != null) {
                    TSF = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    TSF = [];
                  }
                } else if (x == "exchRate") {
                  if (data.tallyTableData[0][x] != null) {
                    EXRT = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    EXRT = [];
                  }
                } else if (x == "finalRateWithoutTax") {
                  if (data.tallyTableData[0][x] != null) {
                    TINV = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    TINV = [];
                  }
                } else if (x == "unit") {
                  if (data.tallyTableData[0][x] != null) {
                    UN = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    UN = [];
                  }
                } else if (x == "currency") {
                  if (data.tallyTableData[0][x] != null) {
                    TCUR = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    TCUR = [];
                  }
                } else if (x == "remark") {
                  if (data.tallyTableData[0][x] != null) {
                    TRE = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    TRE = [];
                  }
                } else if (x == "quantity") {
                  if (data.tallyTableData[0][x] != null) {
                    QUN = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    QUN = [];
                  }
                } else if (x == "containerDetails") {
                  if (data.tallyTableData[0][x] != null) {
                    CON_NO = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    CON_NO = [];
                  }
                } else if (x == "multipleContainerType") {
                  if (data.tallyTableData[0][x] != null) {
                    CONTYPE = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    CONTYPE = [];
                  }
                } else {
                  this.ffInvoiceModal[x] = data.tallyTableData[0][x] || "";
                }
              });

              if (CON_NO.length > 0) {
                this.ffInvoiceModal.containerDetails = CON_NO;
              }
              if (CONTYPE.length > 0) {
                this.ffInvoiceModal.multipleContainerType = CONTYPE;
              }

              if (TParti.length > 0) {
                console.log(TSF);
                TParti.map((x, index) => {
                  let obj = {
                    ffType: x,
                    containerType: TCon[index],
                    quantity: QUN[index],
                    ffSellingRate: TSelO[index],
                    sellingRateFinal: TSF[index],
                    exchRate: EXRT[index],
                    invAmount: TINV[index],
                    unit: UN[index],
                    currency: TCUR[index],
                    remark: TRE[index],
                  };

                  this.ffTallyInvoiceData.push(obj);
                });
              }
              if (data.users && data.users.length > 0) {
                this.editUserName = data.users[0].employeeName;
                this.updateTime = data.tallyTableData[0].updateTime;
              }
            } else {
              this.ffInvSummaryData = data.ffInvSummaryData;
              this.ffInvoiceModal.clientName = data.ffInvSummaryData[0].clientName;
              this.ffInvoiceModal.contact = data.ffInvSummaryData[0].kycContact;
              this.ffInvoiceModal.adress = data.ffInvSummaryData[0].corporateAddress;
              this.ffInvoiceModal.containerDetails = data.ffInvSummaryData[0].ContainerNo.split(
                ","
              );

              // this.ffInvoiceModal.multipleContainerType = data.ffInvSummaryData[0].multipleContainerType.split(
              //   ","
              // );

              // this.ffInvoiceModal.multiConNo = data.ffInvSummaryData[0].multiConNo.split(
              //   ","
              // );

              ///
              let firstArr = data.ffInvSummaryData[0].multipleContainerType.split(",");
              let searry = data.ffInvSummaryData[0].multiConNo.split(",");
              for (let i = 0; i < firstArr.length; i++) {
                let element = firstArr[i];
                let runCount = searry[i];

                for (let y = 0; y < runCount; y++) {
                  console.log(element, runCount);
                  this.ffInvoiceModal.multipleContainerType.push(element);
                  // const _element = element;
                }
              }
              ///

              this.ffInvoiceModal.jobNo = data.ffInvSummaryData[0].ffImportSeries;
              this.ffInvoiceModal.shippingLine = data.ffInvSummaryData[0].shippingLine;
              this.ffInvoiceModal.POD = data.ffInvSummaryData[0].placeDis;
              this.ffInvoiceModal.POR = data.ffInvSummaryData[0].placeRecp;
              this.ffInvoiceModal.FPOD = data.ffInvSummaryData[0].finalPlace;
              this.ffInvoiceModal.LP = data.ffInvSummaryData[0].LoadPort;
              this.ffInvoiceModal.allModuleId = data.ffInvSummaryData[0].allModuleId;
              this.ffInvoiceModal.ffImportId = data.ffInvSummaryData[0].ffImportId;
              this.ffInvoiceModal.ccTypeExImp = data.ffInvSummaryData[0].transportType;
              if (data.quotationData.length > 0) {
                this.ffTallyInvoiceData = data.quotationData;
              } else {
                this.ffTallyInvoiceData = [];
              }
            }

            if (data.ledgerData.length > 0) {
              this.ledgerData = data.ledgerData;
            } else {
              this.ledgerData = [];
            }
            if (data.unitList.length > 0) {
              this.unitList = data.unitList;
            } else {
              this.unitList = [];
            }

            if (data.containerMasterData.length > 0) {
              this.containerMasterData = data.containerMasterData;
            } else {
              this.containerMasterData = [];
            }

            if (this.ffInvoiceModal.allModuleId) {
              this.$store.dispatch(
                "common/setAllSuccessInvoiceTB",
                JSON.stringify({
                  itemCode: "ALL_SUCCESS_INVOICE_TALLY_BILLING",
                  allModuleId: this.ffInvoiceModal.allModuleId,
                  InvoiceTypeKey: "F",
                })
              );
            }

            // if (data.quotationData.length > 0) {
            //     this.ffTallyInvoiceData = data.quotationData;
            //   } else {
            //     this.ffTallyInvoiceData = [];
            //   }

            this.isLoading = false;
            this.getJobNatureOfExpenseList();
          }
        })
        .catch((error) => { });
    },
    getPreviousTallyData(pre_item) {
      console.log("pre_item=>", pre_item);
      // this.ffInvoiceModal.fromAgentColoderTable = pre_item.fromAgentColoderTable;
      // this.ffInvoiceModal.invoiceForClient = pre_item.invoiceForClient;
      // this.ffInvoiceModal.otherChargeFF = pre_item.otherChargeFF;
      // this.ffInvoiceModal.profarmaLocationId = pre_item.profarmaLocationId;
      // this.ffInvoiceModal.profarmaLocationName = pre_item.profarmaLocationName;
      // this.ffInvoiceModal.shipperInvNoforTally = pre_item.shipperInvNoforTally;
      // this.ffInvoiceModal.shipperInvDateforTally = pre_item.shipperInvDateforTally;
      // this.ffInvoiceModal.shipperInvNo = pre_item.shipperInvNo;
      // this.ffInvoiceModal.shipperInvDate = pre_item.shipperInvDate;
      // this.ffInvoiceModal.stateName = pre_item.stateName;
      // this.ffInvoiceModal.clientgst = pre_item.clientgst;
      // this.ffInvoiceModal.grnNo = pre_item.grnNo;
      // this.ffInvoiceModal.pickup = pre_item.pickup;
      // this.ffInvoiceModal.Handover = pre_item.Handover;
      // this.ffInvoiceModal.factoryLoc = pre_item.factoryLoc;
      // // this.ffInvoiceModal.jobType= pre_item.jobTypeNameArr;
      // // this.ffInvoiceModal.jobTypeName= pre_item.jobTypeNameArr;
      // this.ffInvoiceModal.jobNo = pre_item.jobNo;
      // this.ffInvoiceModal.ffExportFclId = pre_item.ffExportFclId;
      // this.ffInvoiceModal.allModuleId = pre_item.allModuleId;
      // this.ffInvoiceModal.ccTypeExImp = pre_item.ccTypeExImp;
      // this.ffInvoiceModal.weight = pre_item.weight;
      // this.ffInvoiceModal.vessel = pre_item.vessel
      //   ? pre_item.vessel
      //   : this.ffInvoiceModal.vessel;
      // this.ffInvoiceModal.blNo = pre_item.blNo;
      // this.ffInvoiceModal.BOE = pre_item.BOE;
      // this.ffInvoiceModal.clientId = pre_item.clientId;
      // this.ffInvoiceModal.clientName = pre_item.clientName;
      // this.ffInvoiceModal.contact = pre_item.contact;
      // this.ffInvoiceModal.adress = pre_item.adress;
      // this.ffInvoiceModal.POR = pre_item.POR;
      // this.ffInvoiceModal.LP = pre_item.LP;
      // this.ffInvoiceModal.POD = pre_item.POD;
      // this.ffInvoiceModal.FPOD = pre_item.FPOD;
      // this.ffInvoiceModal.shippingLine = pre_item.shippingLine;
      // let BLno = this.ffInvoiceModal.blNo.replace(/ /g, "").split(",");
      // console.log("BLno", BLno);
      // BLno = [...new Set(BLno)];
      // console.log("BLno", BLno);
      // this.ffInvoiceModal.blNo = "";
      // this.ffInvoiceModal.blNo = BLno.join(",");
      // console.log("pre_item", pre_item);
      this.getBillData(pre_item);
    },
    getBillData(item) {
      this.ffTallyInvoiceData = [];
      // Object.keys(this.ffInvoiceModal).map((x, index) => {
      //   if(x!=null && x!=undefined){
      //   this.ffInvoiceModal[x] = item[x];
      //   }
      // });
      let TParti = [];
      let TCon = [];
      let TSelO = [];
      let TSF = [];
      let TINV = [];
      let TCUR = [];
      let TRE = [];

      let EXRT = [];
      let QUN = [];
      let UN = [];
      let CON_NO = [];
      let CONTYPE = [];

      if (item.particulars != null) {
        TParti = item.particulars.split(",");
      }
      if (item.containerType != null) {
        TCon = item.containerType.split(",");
      }
      if (item.quantity != null) {
        QUN = item.quantity.split(",");
      }
      if (item.quotationRate != null) {
        TSF = item.quotationRate.split(",");
      }
      if (item.sellingRateFinal != null) {
        TSelO = item.sellingRateFinal.split(",");
      }
      if (item.unit != null) {
        UN = item.unit.split(",");
      }
      if (item.exchRate) {
        EXRT = item.exchRate.split(",");
      }
      if (item.containerDetails) {
        CON_NO = item.containerDetails.split(",") || [];
      } else {
        CON_NO = [];
      }
      if (item.finalRateWithoutTax != null) {
        TINV = item.finalRateWithoutTax.split(",");
      }
      if (item.currency != null) {
        TCUR = item.currency.split(",");
      }
      if (item.remark != null) {
        TRE = item.remark.split(",");
      }

      if (TParti.length > 0) {
        TParti.map((x, index) => {
          let obj1 = {
            ffType: x,
            containerType: TCon[index],
            quantity: QUN[index],
            ffSellingRate: TSelO[index],
            sellingRateFinal: TSF[index],
            exchRate: EXRT[index],
            invAmount: TINV[index],
            unit: UN[index],
            currency: TCUR[index],
            remark: TRE[index],
          };

          this.ffTallyInvoiceData.push(obj1);

          // this.CCCheckDone = 1;
        });
        console.log(this.ffTallyInvoiceData);

        // this.revisedSavedBillingData = this.ffTallyInvoiceData;
      }
    },

    previousSalesView() {
      window.history.go(-1);
      // this.$router.push({
      //   path: "/CCImport/paymentDetail"
      // });
    },

    handleExpensesSaved(expenses) {
      console.log('Expenses saved:', expenses);
      // Handle the saved expenses data
    },

    handleExpenseValidation(validationData) {
      this.expenseValidation = validationData;
      console.log('Expense validation:', validationData);
    },

    // Method to get expense data from child component
    getExpenseData() {
      if (this.$refs.expenseTableComponent) {
        return this.$refs.expenseTableComponent.getAllExpensesData();
      }
      return [];
    },

    // Simple common function to get all expense data
    getExpenseDataSimple() {
      if (!this.$refs.expenseTableComponent) {
        return { all: [], total: 0 };
      }

      const allExpenses = this.$refs.expenseTableComponent.getAllExpensesDataComplete();
      const total = allExpenses.reduce((sum, exp) => {
        return sum + (parseFloat(exp.amountToBePaid) || 0) + (parseFloat(exp.amountToBeBilled) || 0);
      }, 0);

      return { all: allExpenses, total };
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// freightInvoiceForTallyImport.vue?ce45f17c